"use client";

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useDebounce } from "@/hooks/useDebounce";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

interface SelectFilterProps {
  placeholder?: string;
  options?: { value: string; label: string }[];
  label?: string;
  name?: string;
}
const SelectFilter = ({
  placeholder = "Pilih",
  options,
  label,
  name = "select",
}: SelectFilterProps) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [query, setQuery] = useState(searchParams.get(name) ?? "");
  const debouncedValues = useDebounce({ value: query, delay: 400 });

  useEffect(() => {
    const currentParams = new URLSearchParams(searchParams.toString());
    if (debouncedValues.trim()) {
      currentParams.set(name, debouncedValues);
    } else {
      currentParams.delete(name);
    }
    router.push(`?${currentParams.toString()}`);
  }, [name, router, searchParams, debouncedValues]);

  return (
    <div className="w-full">
      {label && <Label className="font-medium mb-1">{label}</Label>}
      <Select value={query} onValueChange={setQuery}>
        <SelectTrigger className="rounded-full border-input h-[2.6rem]">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value=" ">Semua</SelectItem>
            {options?.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SelectFilter;
